import { authDomain } from '@auth';
import { useMutation } from '@tanstack/react-query';

export const useRestorePasswordByPhone = () => {
  return useMutation((payload: authDomain.RestorePasswordDto) => {
    return authDomain.authService.restorePasswordByPhone(payload);
  });
};
